{
  "basepath": "/",
  "interproURL": "https://www.ebi.ac.uk/interpro",
  "ebiSearchURL": "https://www.ebi.ac.uk/ebisearch/ws/rest/interpro7",
  "test": false
}